import { Navigate, useLocation } from "react-router-dom";
import { useAuth, dashboardPathFor } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="route-loading">
        <div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-[#2A8FE0] animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/entrar" replace state={{ from: location }} />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={dashboardPathFor(user.role)} replace />;
  }
  return children;
}
